import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Watches the URL hash and smoothly scrolls to the matching element id
export default function ScrollToHash() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.hash) return;
        const id = location.hash.replace('#', '');

        const prefersReduced =
            typeof window !== 'undefined' &&
            window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Try immediate scroll; if content isn't ready yet, retry quickly
        const attemptScroll = () => {
            const el = document.getElementById(id);
            if (el) {
                // Scroll first
                el.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });

                // Move focus to target or its heading so SR announces context
                // Prefer the first heading inside the section
                const heading = el.querySelector('h1, h2, h3, h4, h5, h6');
                const focusTarget = heading || el;

                const prevTabIndex = focusTarget.getAttribute('tabindex');
                focusTarget.setAttribute('tabindex', '-1');
                focusTarget.focus({ preventScroll: true });

                // After focusing, restore tabindex if it wasn't set before
                const restore = () => {
                    if (prevTabIndex === null) {
                        focusTarget.removeAttribute('tabindex');
                    } else {
                        focusTarget.setAttribute('tabindex', prevTabIndex);
                    }
                };
                // Give focus a moment before restoring
                setTimeout(restore, 200);

                return true;
            }
            return false;
        };

        if (!attemptScroll()) {
            const t = setTimeout(attemptScroll, 50);
            return () => clearTimeout(t);
        }
    }, [location]);

    // Optional: if user hits "/about" directly, redirect to "/#about"
    useEffect(() => {
        if (location.pathname === '/about') {
            navigate('/#about', { replace: true });
        }
    }, [location.pathname, navigate]);

    return null;
}
